import { render, staticRenderFns } from "./UserActionInfoBanPlayer.vue?vue&type=template&id=2e0a8ff8&"
import script from "./UserActionInfoBanPlayer.vue?vue&type=script&lang=js&"
export * from "./UserActionInfoBanPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports